import type React from 'react'
import { useEffect, useState } from 'react'
import { cn } from '../../lib/utils'

interface NumberTickerProps {
    value: number
    className?: string
    decimals?: number
    prefix?: string
    suffix?: string
    duration?: number // duration in ms
}

export const NumberTicker: React.FC<NumberTickerProps> = ({
    value,
    className = '',
    decimals = 0,
    prefix = '',
    suffix = '',
    duration = 500,
}) => {
    const [displayValue, setDisplayValue] = useState(value)

    useEffect(() => {
        let startTime: number
        const startValue = displayValue
        const endValue = value

        // If difference is small or 0, just set it immediately to avoid unnecessary animation logic
        if (Math.abs(endValue - startValue) < Number.EPSILON) {
            setDisplayValue(endValue)
            return
        }

        const tick = (timestamp: number) => {
            if (!startTime) startTime = timestamp
            const progress = Math.min((timestamp - startTime) / duration, 1)

            // Ease out quart
            const ease = 1 - (1 - progress) ** 4

            const current = startValue + (endValue - startValue) * ease
            setDisplayValue(current)

            if (progress < 1) {
                requestAnimationFrame(tick)
            }
        }

        requestAnimationFrame(tick)
    }, [value, duration])

    return (
        <span className={cn(className)}>
            {prefix}
            {displayValue.toFixed(decimals)}
            {suffix}
        </span>
    )
}
